import { useState, useEffect } from 'react';

export default function EditInvoiceModal({ isOpen, onClose, invoice, onSave, isLoading }) {
  const [formData, setFormData] = useState({
    status: '',
    payment_method: '',
  });

  useEffect(() => {
    if (invoice) {
      setFormData({
        status: invoice.status || 'pending_payment',
        payment_method: invoice.payment_method || '',
      });
    }
  }, [invoice]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed text-left inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[99]">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md mx-4">
        <h3 className="text-lg font-bold mb-4">Modifier la facture</h3>
        
        <form onSubmit={handleSubmit}>
          <div className="space-y-4">
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Méthode de paiement
              </label>
              <select
                value={formData.payment_method}
                onChange={(e) => setFormData({...formData, payment_method: e.target.value})}
                className="w-full cursor-pointer p-2 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-500)]"
              >
                <option value="" >-- Sélectionner --</option>
                <option value="cash">Espèces</option>
                <option value="cheque">Chèque</option>
                <option value="bank_transfer">Virement bancaire</option>
                <option value="credit_card">Carte bancaire</option>
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Statut
              </label>
              <select
                value={formData.status}
                onChange={(e) => setFormData({...formData, status: e.target.value})}
                className="w-full cursor-pointer p-2 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-500)]"
                required
              >
                <option value="pending_payment">En attente</option>
                <option value="paid">Payé</option>
                <option value="cancelled">Annulé</option>
              </select>
            </div>
          </div>
          
          <div className="flex gap-2 mt-6">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 text-xs cursor-pointer bg-gray-300 hover:bg-gray-400 text-gray-700 py-2 px-4 rounded-xl disabled:opacity-50"
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 text-xs cursor-pointer bg-[var(--color-primary-500)] hover:bg-[var(--color-primary-400)] text-white py-2 px-4 rounded-xl disabled:opacity-50"
            >
              {isLoading ? 'Enregistrement...' : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}